<div fxLayout="column" fxLayoutGap="10px" [ngStyle]="{'max-height.px': innerHeight}" class="layout-padd">

    <!-- Error message -->
    <div *ngIf="errorMessage" class="layout-padd warn rad-bord text-center">
        <span class="mat-subheading-1">{{errorMessage}}</span>
    </div>

    <div fxLayout="column" class="bordered-card">

        <!-- Amount -->
        <div fxLayout="row" fxLayoutAlign="space-between" class="layout-padd">
            <span class="mat-subheading-1"> {{'confirmRechargeComponent.amount' | translate}}</span>
            <span class="mat-subheading-1 boldest">{{ amount | priceFilter }}</span>
        </div>

        <!-- Card -->
        <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="paymentType === 'online'" class="layout-padd divider-top">
            <span class="mat-subheading-1">{{'confirmRechargeComponent.card' | translate}}</span>
            <span class="mat-subheading-1 boldest">**** **** **** {{ card.card.last4 }}</span>
        </div>

    </div>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center" *ngIf="paymentType === 'online'">

       <button fxFlex mat-stroked-button class="warn-ico" (click)="dialogRef.close()" angulartics2On="click" angularticsAction="cancelRecharge" angularticsCategory="rechargeCard">
        {{'button.cancel'|translate }}
    </button>

        <button fxFlex mat-stroked-button class="great-ico" (click)="dialogRef.close(true)" angulartics2On="click" angularticsAction="confirmRecharge" angularticsCategory="rechargeCard">
            {{'confirmRechargeComponent.confirm' | translate}}
    </button>

    </div>


    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center" *ngIf="paymentType === 'online_paypal'">

        <button fxFlex mat-stroked-button class="warn-ico" (click)="dialogRef.close()" angulartics2On="click" angularticsAction="cancelRecharge" angularticsCategory="rechargeCard">
            {{'button.cancel'|translate }}
     </button>
 
     <div fxFlex >
        <div #paypal></div>
     </div>


</div>
    <!-- <div fxLayout="column" *ngIf="paymentType === 'online_paypal'">
        <div #paypal></div>
        <button fxFlex mat-stroked-button class="warn-ico" style="height: 40px;" (click)="dialogRef.close()" angulartics2On="click" angularticsAction="cancelRecharge" angularticsCategory="rechargeCard">
        Annuler
      </button>
    </div> -->

</div>